// extracted by mini-css-extract-plugin
export var currencyInput = "_i8-1";
export var currencySymbol = "_i8-0";